import { Templates } from '../../compile';
import { CommandOptions } from '../../interfaces/options';

export const DefaultCommandOptions: CommandOptions = {
	template: Templates.table_column_command,
	label: null,
	css: null,
	command: () => {},
	visible: () => true,
	editable: () => true
};
